import React from 'react';
import SimpleCard from './SimpleCard';
import { SimpleCardData } from '../common/types';

interface SimpleCardContainerProps {
    cards: SimpleCardData[];
}

const SimpleCardContainer: React.FC<SimpleCardContainerProps> = ({ cards }) => {
    return (
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5'>
            {cards.map((card, index) => (
                <SimpleCard key={index} image={card.image} title={card.title} count={card.count} />
            ))}
        </div>
    );
};

export default SimpleCardContainer;
